import React, { useEffect, useState } from 'react';
import { Input, Button, Divider, Form } from 'antd';
import Ruler from 'rc-ruler';
import 'rc-ruler/dist/index.css';
import './index.less';
const pacleHolder = '宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度宽度';
// 可编辑组件
const EditNode = (props) => {
    // const [name, setName] = useState(props.value);
    const [dragLen, setDragLen] = useState(0);
    const [form] = Form.useForm();
    const [pacleHolderData, setPacleHolderData] = useState(pacleHolder);
    useEffect(() => {
        // setName(props.value);
        if (props.nodeType === 'string') {
            form === null || form === void 0 ? void 0 : form.setFieldsValue({
                name: props.value,
            });
        }
        if (props.nodeType === 'number') {
            setDragLen(props.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value]);
    // const titleChange = (e) => {
    //     setName(e);
    // };
    useEffect(() => {
        if (props.dragHolderMessag) {
            let i = 1;
            let str = props.dragHolderMessag;
            while (i < 10) {
                str += props.dragHolderMessag;
                i++;
            }
            setPacleHolderData(str);
        }
    }, [props.dragHolderMessag]);
    const titleSave = () => {
        console.log(form.getFieldsValue());
        let value = '';
        if (props.nodeType === 'string') {
            value = form.getFieldValue('name');
        }
        if (props.nodeType === 'number') {
            value = dragLen;
        }
        props.changeName && props.changeName(true, props.type, props.id, props.name, value);
    };
    const titleCancel = () => {
        if (props.nodeType === 'string') {
            form.setFieldsValue({
                name: props.value,
            });
        }
        if (props.nodeType === 'number') {
            setDragLen(props.value);
        }
        props.changeName && props.changeName(false, props.type, props.id);
    };
    const handleDragChange = (value) => {
        setDragLen(value);
    };
    return (<>
            <Form name="basic" form={form} onFinish={titleSave}>
                {props.nodeType === 'string' && (<Form.Item name="name" rules={[{ required: true, whitespace: true, message: '内容不能为空！' }]}>
                        <Input 
        // onChange={(e) => titleChange(e.target.value)}
        allowClear addonAfter={<>
                                    <Button type="link" htmlType="submit">
                                        保存
                                    </Button>
                                    <Divider type="vertical"/>
                                    <Button type="link" onClick={titleCancel}>
                                        取消
                                    </Button>
                                </>}/>
                    </Form.Item>)}
                {props.nodeType === 'number' && (<>
                        {/* <Space> */}
                        {/* <InputNumber value={name} onChange={titleChange} min={1} /> */}
                        <div style={{ width: `${dragLen}px`, overflow: 'hidden', height: 20 }}>{pacleHolderData}</div>
                        <div style={{ width: `${dragLen > 300 ? 500 : 300}px` }}>
                            {/* <div style={{ width: 500 }}> */}
                            <Ruler value={dragLen} onDrag={handleDragChange} start={0} end={dragLen > 300 ? 500 : 300} step={50}/>
                            {/* </div> */}
                            {/* <Form.Item
                name="name"
                rules={[{ required: true, whitespace: true, message: '内容不能为空！' }]}
            > */}

                            {/* </Form.Item> */}
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <Button type="link" onClick={() => titleSave()}>
                                保存
                            </Button>
                            <Divider type="vertical"/>
                            <Button type="link" onClick={titleCancel}>
                                取消
                            </Button>
                        </div>
                        {/* </Space> */}
                    </>)}
            </Form>
        </>);
};
export default EditNode;
